import { create } from 'zustand';

export const operatorProfileStore = (set) => ({
  openOperatorProfile: false,
  operatorId: null,
  setOpenOperatorProfileView: (data) => {
    set({ openOperatorProfile: data });
  },
  setOperatorId: (data) => {
    set({ operatorId: data });
  },
});
export const useOperatorProfileStore = create(operatorProfileStore);
